import React,{ useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { logUI } from '../../../api/andyliticsApi';
import { Typography, CircleButton, Icon, LinkText } from '../../ecosystem';
import { CircleButtonTooltip, LinkedCard } from '../../ecosystem/mybswh';
import * as Tools from "../../../helpers/Tools";
import useTiles from "./hooks/useTiles";


//{
//    href,
//        image,
//        index,
//        label,
//        show,
//        borderStyle,
//        className,
//        onClick,
//        target
//}
/*
--"tileId": 85,//id
--"imageUrl": "https://bswcdndesign-prod.bswhealth.com/content/img/features-video-visit.svg",//image
"tags": "video-visit DiscoverSomethingNew",
--"sortOrder": 1,//oridnal
--"name": "Try a video visit",//label
"featureName": "DiscoverSomethingNew",
"title": "Try a video visit",
"actionType": "LINK",
--"actionLink": "_test_tile",//href
"requiresAuthentication": false,
"allMemberships": true,
"specificMemberships": "",
--"isDismissed": false//dismissed
*/
const DiscoverNewTile = (props) => {
    const goToFeature = (href) => {
        logUI(`MBHWeb.UI.DiscoverNewTile.${props.name}.Clicked`, new Date(), Tools.getURLPath());
    };
    const dismissDiscovery = () => {
        props.onXClick({ ...props,isDismissed:true });
    }
    const discoverTileClasses = [
        `${'discover-tile-card'}`
    ].join(' ');

    const imgUrl = props.imageUrl;
    const tileImg = imgUrl.indexOf('bswcdndesign') !== -1 && imgUrl.indexOf("features") !== -1
            ? imgUrl.substr(0, imgUrl.lastIndexOf(".")) + ".svg" : imgUrl; //mobile app needs to keep as PNG so switching to SVG for web

    return <>
        <div className="discover-tile__dismiss">
            <LinkText
                as={<button type="button"></button>}
                onClick={dismissDiscovery}
            >
                <Icon
                    name="x"
                    aria-label={"dismiss"}
                />
            </LinkText>
        </div>
        <LinkedCard
            className={discoverTileClasses}
            onClick={goToFeature}
            target={props.target}
            to={{ pathname: props.actionLink }}
            disabled={props?.disabled??false}
            hoverStyle={"shadow"}
        >
        <div className="discover-tile-card-content-container">
            <div className="discover-tile-head row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <Typography bold
                                color="$color-primary-a2"
                                type="heading-01">{props.name}</Typography>
                        </div>
                    </div>
                </div>
            </div>
            <div className="discover-tile-content row">
                <div className="col-12">
                    <img className="discover-tile__img" alt={props.name} src={tileImg} />
                </div>
            </div>
            <div className="discover-tile-footer row">
                <div className="col-12 discover-tile__button">
                    <CircleButton
                        name="arrow"
                        as={'div'}
                        colorStyle="default"
                    />
                </div>
            </div>
        </div>
    </LinkedCard>
    </>;
}
export default withRouter(DiscoverNewTile);